<section class="tax-advantage-section py-5">
    <div class="container py-5">

      <!-- Badge -->
      <div class="d-flex justify-content-center mb-4">
        <div class="tax-badge d-flex align-items-center justify-content-center">
          <div class="tax-badge-inner d-flex flex-column align-items-center justify-content-center text-center">
            <div class="tax-badge-value">{{ tax_data.badge_value }}</div>
            <div class="tax-badge-label text-uppercase text-xs fw-semibold">
              {{ tax_data.badge_label }}
            </div>
          </div>
        </div>
      </div>

      <!-- Kicker -->
      <div class="d-flex justify-content-center mb-3">
        <div class="d-flex align-items-center gap-3 text-uppercase text-xs fw-semibold tax-kicker">
          <span class="tax-kicker-line"></span>
          <span>{{ tax_data.kicker }}</span>
        </div>
      </div>

      <!-- Title -->
      <h2 class="text-center tax-title mb-3">
        {{ tax_data.title }}
      </h2>

      <!-- Copy -->
      <p class="text-center tax-lead mx-auto mb-0">
        {{ tax_data.description }}
      </p>

    </div>
  </section>
